/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { SiteSystemIsMotorised } from "./site-system-is-motorised";
import { SiteSystemIsOurs } from "./site-system-is-ours";

export class SiteSystem {
    id: number;
    name: string;
    notes: string;
    isMotorised: SiteSystemIsMotorised;
    isOurs: SiteSystemIsOurs;
    isLowVoltage: boolean;
    isHighLevel: boolean;
}
